<template>
  <div class="date-q">
    <el-date-picker
      v-model="ymdValue"
      :value-format="typeFormat"
      :format="typeFormat"
      :type="dateType"
      placeholder="选择日期"
      :picker-options="pickerOptions"
      @change="onChangeYmd"
      :disabled="view"
    />
    <el-time-picker
      v-if="showTimePicker"
      :disabled="disabledTimePicker"
      v-model="timeValue"
      :value-format="timeFormat"
      :format="timeFormat"
      :picker-options="timeOptions"
      placeholder="选择时间"
      @change="onChangeTimeValue"
    ></el-time-picker>
  </div>
</template>

<script>
import { compareDate } from 'dygc'

export default {
  name: 'DateQ',
  changeExpr: 'issue.value',
  data() {
    const issue = this.question.issue
    let min = new Date(issue.min || '1900-01-01')
    let max = new Date(issue.max || '9012-12-31')
    if (issue.validateType === 'relativeTime') {
      let d = new Date()
      min = new Date(d.getTime() + issue.min * 1000 * 60 * 60 * 24)
      max = new Date(min.getTime() + issue.range * 1000 * 60 * 60 * 24)
    }

    return {
      ymdValue: '',
      timeValue: '',
      pickerOptions: {
        disabledDate(date) {
          let c1 = compareDate(date, min, 3)
          if (c1 < 0) return true
          let c2 = compareDate(date, max, 3)
          if (c2 > 0) return true
        }
      },
      timeOptions: null,
      timeFormat: '',
      min,
      max
    }
  },
  computed: {
    dateType() {
      switch (this.issue.dateType) {
        case 'year':
          return 'year'
        case 'month':
          return 'month'
        default:
          return 'date'
      }
    },
    typeFormat() {
      switch (this.issue.dateType) {
        case 'year':
          return 'yyyy'
        case 'month':
          return 'yyyy-MM'
        default:
          return 'yyyy-MM-dd'
      }
    },
    showTimePicker() {
      return ['分', '秒'].includes(this.issue.dateType)
    },
    disabledTimePicker() {
      return !this.ymdValue || this.view
    }
  },
  methods: {
    onChangeYmd() {
      this.initTimeOptions()
      if (!this.showTimePicker) {
        this.issue.value = this.ymdValue
      }
    },
    onChangeTimeValue() {
      this.issue.value = `${this.ymdValue} ${this.timeValue}`
    },
    initTimeOptions() {
      let selectableRange = '00:00:00 - 23:59:59'
      let ymd = new Date(this.ymdValue)
      let min = this.min
      let max = this.max
      let cmin = compareDate(ymd, this.min, 3)
      let cmax = compareDate(ymd, this.max, 3)

      const minStr = `${min.getHours()}:${min.getMinutes()}:${min.getSeconds()}`
      const maxStr = `${max.getHours()}:${max.getMinutes()}:${max.getSeconds()}`

      if (compareDate(this.min, this.max) === 0) {
        selectableRange = `${minStr} - ${maxStr}`
      } else if (cmin === 0) {
        selectableRange = `${minStr} - 23:59:59`
      } else if (cmax === 0) {
        selectableRange = `00:00:00 - ${maxStr}`
      }

      if (this.issue.dateType === '分') {
        this.timeOptions = {
          selectableRange,
          format: 'HH:mm'
        }
        this.timeFormat = 'HH:mm'
      } else {
        this.timeOptions = {
          selectableRange,
          format: 'HH:mm:ss'
        }
        this.timeFormat = 'HH:mm:ss'
      }
    }
  },
  created() {
    this.initTimeOptions()
  },
  mounted() {
    if (this.issue.value) {
      const [ymd, time] = this.issue.value.split(' ')
      this.ymdValue = ymd
      this.timeValue = time || ''
    }
  }
}
</script>
